/*************************************************/
/* LOTTIE ANIMATIONS                             */
/*************************************************/
import lottie from "lottie-web";

export function lottieAnimation() {
    const init = function () {
        const lottieElements = document.querySelectorAll(".lottie");

        lottieElements.forEach(function (element) {
            const animationPath = element.getAttribute("data-lottie-json");
            const loop = true; // Default loop value
            const delay = 0;   // Default delay value

            const animation = lottie.loadAnimation({
                container: element,
                renderer: 'svg',
                loop: loop,
                autoplay: false,
                path: animationPath
            });

            element.lottieInstance = animation;

            if (element.classList.contains("lottie-hover")) {
                // Handle via hover
                element.addEventListener("mouseenter", () => animation.play());
                element.addEventListener("mouseleave", () => animation.stop()); 
            } else {
                // Handle via intersection
                const observer = new IntersectionObserver(handleIntersection, { threshold: [0, 0.5, 1] });
                observer.observe(element);

                function handleIntersection(entries) {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (delay > 0) {
                                setTimeout(() => {
                                    animation.play();
                                }, delay);
                            } else {
                                animation.play();
                            }
                        } else {
                            animation.pause();
                        }
                    });
                }
            }
        });
    };

    init();
}
